<template>
  <div class="padding-zero">
    <table-header
      :title="'Logi'"
      :withPagination="true"
      :dispatchAction="'getAllLogs'"
      :onPage="this.logs.data.on_page"
      :pageNumber="this.logs.data.page_number"
      :total="this.logs.data.total"
      :refreshAction="true"
      :tableName="'logs'"
      :withFilters="true"
      :filters="filteringOptions"
      :withoutSearchInput="true"
    ></table-header>

    <table class="table table-stripped">
      <thead>
        <tr class="tr-table">
          <th scope="col">ID</th>
          <th scope="col">Typ</th>
          <th scope="col">Data utworzenia</th>
          <th scope="col">ID użytkownika</th>
          <th scope="col">Telefon</th>
          <th scope="col">Poprzedni numer telefonu</th>
          <th scope="col">Kogo dotyczy</th>
          <th scope="col">Wykonał</th>
          <th scope="col">Opis</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="log in logs.data.logs" :key="log.id">
          <td>{{ log.id }}</td>
          <td>{{ log.log_type }}</td>
          <td>{{ formattedDate(log.creationDate) }}</td>
          <td>{{ log.user ? log.user.id : "-" }}</td>
          <td>{{ log.user ? log.user.phone : "-" }}</td>
          <td>
            {{
              log.user && log.user.previous_phone
                ? log.user.previous_phone
                : "Brak"
            }}
          </td>
          <td>{{ log.target_phone || "-" }}</td>
          <td>{{ log.performed_by || "-" }}</td>
          <td>{{ log.description || "-" }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import shared from "../shared";
import TableHeader from "../components/TableHeader";
export default {
  name: "logs",
  components: {
    TableHeader,
  },
  computed: {
    logs() {
      return this.$store.getters.getLogs;
    },
  },
  created() {
    if (this.$route.params.userId) {
      this.$store.dispatch("getAllLogs", {
        user_id: this.name,
      });
    } else {
      this.$store.dispatch("getAllLogs", {});
    }

    this.formattedDate = shared.formattedDate;
  },
  data() {
    return {
      name: this.$route.params.userId ? this.$route.params.userId : "",
      sort: "",
      filteringOptions: [
        {
          name: "ALL",
          displayName: "Wszystkie",
        },
        {
          name: "LOG_IN",
          displayName: "LOG_IN",
        },
        {
          name: "SEARCH_EMPLOYEE",
          displayName: "SEARCH_EMPLOYEE",
        },
        {
          name: "GET_EMPLOYEE_DETAILS",
          displayName: "GET_EMPLOYEE_DETAILS",
        },
        {
          name: "DNR_LINK",
          displayName: "DNR - połączenie kont",
        },
        {
          name: "DNR_UNLINK",
          displayName: "DNR - rozłączenie kont",
        },
        {
          name: "DNR_RATE_UPDATE",
          displayName: "DNR - zmiana stawki",
        },
        {
          name: "DNR_SERVICE_AUTO_CREATE",
          displayName: "DNR - auto-utworzenie usługi",
        },
        {
          name: "PROFILE_UPDATE",
          displayName: "Profil - zmiana danych",
        },
        {
          name: "ACCOUNT_NUMBER_CHANGE",
          displayName: "Profil - zmiana numeru konta",
        },
        {
          name: "DNR_FINISH",
          displayName: "DNR - zakończenie zleceń (rozliczenie)",
        },
        {
          name: "DNR_ORDER_REMOVED",
          displayName: "DNR - usunięcie zlecenia z rachunku",
        },
        {
          name: "DNR_SERVICE_VERIFY",
          displayName: "DNR - weryfikacja usługi",
        },
        {
          name: "PANEL_ACCESS_REVOKE",
          displayName: "Panel - odebranie dostępu",
        },
        {
          name: "DNR_SERVICE_REMOVED",
          displayName: "DNR - usunięcie usługi przez admina",
        },
      ],
    };
  },
};
</script>

<style scoped>
h1 {
  margin: auto;
}
.top {
  margin: 10px 10px;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
}
.management-panel {
  display: flex;
  justify-content: space-between;
}
.disabled-icon {
  color: rgba(182, 182, 182, 0.571);
}
.menagment-panel {
  display: flex;
}
.menagment-panel .disabled-icon {
  color: rgba(182, 182, 182, 0.571);
}

i {
  font-size: 30px !important;
  cursor: pointer;
  margin: 5px;
  transform: translateY(7px);
}

.menagment-panel button {
  margin: 0px 5px;
}
.filterPanel {
  display: flex;
  align-content: center;
  justify-content: center;
}
.filterSelect {
  margin-right: 5px;
}
</style>
